/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-20 13:47:57
 * @LastEditTime: 2025-08-04 10:05:35
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import { OrderProduct } from '../../order/model';
import { getBuyWay } from '@/utils';
import './index.scss';

const OrderCell = (props: OrderProduct) => {
    // 获取购买方式
    // const getBuyWay = (type:string) => {
    //   switch (type) { 
    //     case '0':
    //       return '永久授权';
    //     case '1':
    //       return '按日购买';
    //     case '2':
    //       return '按周购买';
    //     case '3':
    //       return '按月购买';
    //     case '4':
    //       return '按季购买';
    //     case '5':
    //       return '按年购买';
    //     case '10':
    //       return '按次购买';
    //     break;
          
    //   }
    // }
  const hadnleGoodsDetail = () => {
    window.open(`/detail?productSn=${props.productSn}`);
  };
  
  return (
    <div className="order-cell-wrap">
      
      <div className="cover" onClick={hadnleGoodsDetail}>
        <img src={props.pmsFiles[0].url} height={90} alt="" />
      </div>
      <div className="info-box" onClick={hadnleGoodsDetail}>
        <div className="line1-text">{props.productName}</div>
        <div className="line2-text">{props.models.find((v: any) => v.type === 1)?.models} { props?.unit&&getBuyWay(props?.unit)}</div>
      </div>

      <div className="tail-box">
        <div className="count">x{props.quantity}</div>
        <div className="price">
          <span>￥</span>
          <span>{props.models.find((v:any)=>v.type===1)?.price}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderCell;
